module.exports = __webpack_public_path__ + "static/cnc-logo-02925b6056ebd9b627e7f6472de9abdf.png";